// extracted by mini-css-extract-plugin
module.exports = {"redirectionPage":"program-module--redirectionPage--PgbBF","modalDialog":"program-module--modalDialog--2ZTKC","previewVideo":"program-module--previewVideo--3D8_U"};